module.exports = __webpack_public_path__ + "static/img/Toby-Rodwell.9f54f97.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Toby-Rodwell.jpg
// module id = g4CR
// module chunks = 0